/*
 * @Description:
 * @Author: Rfan
 * @Date: 2020-04-28 10:15:24
 * @LastEditTime: 2024-08-21 18:01:40
 */
/**
 * @module utils/index
 */
/** 
 * 工具类
 * @fileoverview 工具类
 
 * @author Rfan
 */
 import store from '@/store';
/**
 * @description 格式化时间为指定格式
 * @param {(Date|Object)} date 原始时间
 * @param {string} format=yyyy-MM-dd hh:mm:ss 时间格式
 * @returns {string} 格式化后的时间字符串
 */
export function parseDate(date, format = "yyyy-MM-dd hh:mm:ss") {
  if (arguments.length === 0) {
    return null;
  }
  let pDate;
  if (typeof date === "object") {
    pDate = date;
  } else {
    return null;
  }
  const formatObj = {
    yyyy: pDate.getFullYear(),
    MM: pDate.getMonth() + 1,
    dd: pDate.getDate(),
    hh: pDate.getHours(),
    mm: pDate.getMinutes(),
    ss: pDate.getSeconds(),
  };
  const dateStr = format.replace(/(y{4}|MM|dd|hh|mm|ss)+/g, (result, key) => {
    const value = formatObj[key];
    return value.toString().padStart(2, "0");
  });
  return dateStr;
}

export function platform() {
  if (store.getters.getQuery?.platform?.toLowerCase().indexOf('harmony') >= 0) {
    return 'harmony';
  }
  let system = "";
  let ua = navigator.userAgent;
  let p = navigator.platform;
  let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  let isMac = !!ua.match(/\(Macintosh.+Mac OS X/); // mac
  let isHarmony = /Harmony/.test(ua);
  if (isHarmony) {
    return 'harmony';
  } else if (isMac) {
    if (p.indexOf("Mac") == 0) {
      system = "ios";
    } else {
      system = "ios";
    }
  } else if (isiOS) {
    system = "ios";
  } else {
    system = "android";
  }
  return system;
}

export function testPlatform(os) {
  return platform() === os;
}

export function isMac() {
  let ua = navigator.userAgent;
  return !!ua.match(/\(Macintosh.+Mac OS X/);
}

export function isPC() {
  const ua = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  for (let i = 0; i < Agents.length; i++) {
    if (ua.indexOf(Agents[i]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function checkClient() {
  const ua = navigator.userAgent;
  return {
    weibo: /Weibo/i.test(ua),
    MicroMessenger: /MicroMessenger/i.test(ua),
    qq: /MQQBrowser/i.test(ua),
    mobile: /AppleWebKit.*Mobile.*/i.test(ua),
    ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua),
    android: /Android/i.test(ua) || /Linux/i.test(ua),
    iPhone: /iPhone/i.test(ua),
    iPad: /iPad/i.test(ua),
    mac: /Macintosh.+Mac OS X/i.test(ua)
  };
}

/**
 * @description: 检测APP名称
 * @return {string} app name
 */
 export function checkoutApp() {
  let name = '';
  const baseQuery = store.getters.getQuery;
  const url = window.location.href;
  if (baseQuery?.channel?.toLowerCase().indexOf('panda') >= 0 || url.indexOf('//static.pandapaint.net') >= 0) {
    name = 'panda';
  } else if (baseQuery?.channel?.toLowerCase().indexOf('pro') >= 0) {
    name = 'hsjpro';
  } else if (baseQuery?.channel?.toLowerCase().indexOf('wap') >= 0) {
    name = 'wap';
  } else {
    name = 'hsj';
  }
  return name;
}


/**
 * @description 判断客户端版本号是否大于给定版本号
 * @param {number} androidVer 安卓版本
 * @param {number} iosVer ios版本
 * @param {number} pandaAndroidVer 熊猫安卓版本
 * @param {number} iopandaIosVersVer 熊猫ios版本
 * @param {number} hsjproAndroidVer 画世界pro安卓版本
 * @param {number} hsjproIosVers 画世界pro ios版本
 * @return {boolean}
 */
 export function checkVer(androidVer, iosVer, pandaAndroidVer = 0, pandaIosVer = 0, hsjproAndroidVer = 0, hsjproIosVer = 0) {
  let ver = store.getters.getVersion;
  if (testPlatform('ios')) {
    ver = parseInt(ver.replace(/\./g, ""));
    console.log('ios ver', ver, iosVer, pandaIosVer, parseInt(ver));
    if (checkoutApp() === 'panda') {
      try {
        if (ver && parseInt(ver) >= pandaIosVer) {
          return true;
        }
        return false;
      } catch (err) {
        console.log(err);
        return false;
      }
    } else if (checkoutApp() === 'hsjpro') {
      try {
        if (ver && parseInt(ver) >= hsjproIosVer) {
          return true;
        }
        return false;
      } catch (err) {
        console.log(err);
        return false;
      }
    } else {
      try {
        if (ver && parseInt(ver) >= iosVer) {
          return true;
        }
        return false;
      } catch (err) {
        console.log(err);
        return false;
      }
    }
  } else {
    console.log('android ver', ver, androidVer, pandaAndroidVer);
    if (checkoutApp() === 'panda') {
      if (ver && ver.verCode >= pandaAndroidVer) {
        return true;
      }
    } else if (checkoutApp() === 'hsjpro') {
      if (ver && ver.verCode >= hsjproAndroidVer) {
        return true;
      }
    } else {
      if (ver && ver.verCode >= androidVer) {
        return true;
      }
    }
    return false;
  }
}

/**
 * @description: 判断链接是否携带域名，没有携带自动添加域名
 * @param {String} url
 * @return {String}
 */

 export function parseImgUrl(url) {
  if (!url) {
    return '';
  }
  if (url.indexOf('http') !== 0) {
    return `${store.getters.getImgBaseUrl}${url}`;
  } else {
    return url;
  }
}

/**
 * @description 格式化评论中 at 用户
 * @param {String} content 原始内容
 * @param {Boolean} clickable 用户是否可点击跳转
 * @return {String} 格式化后的content
 */
 export function initAt(content, clickable) {
  if (!content) {
    return "";
  }
  const reg = /@{"id":(\d+)\s*,\s*"nick":"([^\}]+)"}/g;

  content = content
    ? clickable ? content.replace(reg, ` <a href='https://www.huashijie.art/user/index/${"$1"}' target="_blank" class="el-link el-link--primary user-jump-link">@${"$2"}</a> `) : content.replace(reg, "@$2 ")
    : "";
  content.replace(/<(\s?|\s+)script/g, " * ");
  return content;
}

/**
 * @description: 检测APP名称
 * @param {string} name
 * @return {string} app name
 */
export function testApp(name) {
  return checkoutApp() === name;
}

/**
 * 🍎ios客户端方法
 * @param {iosCallback} callback - The callback that handles the response.
 */
export function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}

import CallApp from "callapp-lib";

export function generateCallLib(app) {
  let callOptions = {
      scheme: {
          protocol: "huashijie"
      },
      appstore:
      "https://apps.apple.com/cn/app/%E7%94%BB%E4%B8%96%E7%95%8C/id1450111327",
      yingyongbao: "https://a.app.qq.com/o/simple.jsp?pkgname=net.huanci.hsj",
      fallback: "https://a.app.qq.com/o/simple.jsp?pkgname=net.huanci.hsj",
      timeout: 5000
  };
  if(app === "panda") {
      callOptions = {
          scheme: {
              protocol: "pandapaint",
          },
          appstore:
          "https://apps.apple.com/us/app/%E7%86%8A%E7%8C%AB%E7%BB%98%E7%94%BB/id1545725960",
          yingyongbao: "https://static.pandapaint.net/pagesart/wap/#/download",
          fallback: "https://static.pandapaint.net/pagesart/wap/#/download",
          timeout: 5000,
      };
  }
  if(app === "hsjpro") {
      callOptions = {
        scheme: {
          protocol: "huashijiepro",
        },
        appstore: "https://hsjpro.mojing.art/",
        yingyongbao: "https://hsjpro.mojing.art/",
        fallback: "https://hsjpro.mojing.art/",
        timeout: 5000,
      };
  }
  return new CallApp(callOptions);
}

// 判断APP login js 支持版本
export function loginSupport() {
  return checkVer(224, 276, 159, 277, 163, Number.MAX_SAFE_INTEGER);
}

// 判断APP 模版安装并打开 js 支持版本
export function templateInstallAndOpenSupport() {
  return checkVer(224, 276, 159, 277, 163, Number.MAX_SAFE_INTEGER);
}

// 判断APP 是否支持ShareV2
export function ShareV2Support() {
  return checkVer(214, 270, 150, 270, 141, 0);
}

// 判断APP 是否支持OSS 改造后逻辑
export function OSSUpdateSupport() {
  return checkVer(209, 0, 146, 0, 157, 0);
}
